import { ReactComponent as Planning } from '../../images/icon-planning.svg';
import { ReactComponent as Calendar } from '../../images/icon-calendar.svg';
import { ReactComponent as Todo } from '../../images/icon-todo.svg';
import { ReactComponent as Reminders } from '../../images/icon-reminders.svg';

export const FEATURES = [
  { text: 'Todo List', icon: <Todo /> },
  { text: 'Calendar', icon: <Calendar /> },
  { text: 'Reminders', icon: <Reminders /> },
  { text: 'Planning', icon: <Planning /> },
];

export const COMPANY = [
  { text: 'History' },
  { text: 'Our team' },
  { text: 'Blog' },
]